import { render, staticRenderFns } from "./agentPriceInfo.vue?vue&type=template&id=1203f339&scoped=true&"
import script from "./agentPriceInfo.vue?vue&type=script&lang=js&"
export * from "./agentPriceInfo.vue?vue&type=script&lang=js&"
import style0 from "./agentPriceInfo.vue?vue&type=style&index=0&id=1203f339&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1203f339",
  null
  
)

export default component.exports